/* tslint:disable */

declare var Object: any;
export interface SkillingLicensesInterface {
  "sfdcId"?: string;
  "IsDeleted"?: boolean;
  "Name"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "LastModifiedDate"?: Date;
  "LastModifiedById"?: string;
  "Resource_Worker__c"?: string;
  "PDF_Attached__c"?: boolean;
  "Is_this_document_on_File__c"?: boolean;
  "License_Detail__c"?: string;
  "License_Number__c"?: string;
  "License_Issue_Date__c"?: Date;
  "License_Expiration_Date__c"?: Date;
  "Skilling__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class SkillingLicenses implements SkillingLicensesInterface {
  "sfdcId": string;
  "IsDeleted": boolean;
  "Name": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "LastModifiedDate": Date;
  "LastModifiedById": string;
  "Resource_Worker__c": string;
  "PDF_Attached__c": boolean;
  "Is_this_document_on_File__c": boolean;
  "License_Detail__c": string;
  "License_Number__c": string;
  "License_Issue_Date__c": Date;
  "License_Expiration_Date__c": Date;
  "Skilling__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: SkillingLicensesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SkillingLicenses`.
   */
  public static getModelName() {
    return "SkillingLicenses";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SkillingLicenses for dynamic purposes.
  **/
  public static factory(data: SkillingLicensesInterface): SkillingLicenses{
    return new SkillingLicenses(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SkillingLicenses',
      plural: 'SkillingLicenses',
      path: 'SkillingLicenses',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Resource_Worker__c": {
          name: 'Resource_Worker__c',
          type: 'string'
        },
        "PDF_Attached__c": {
          name: 'PDF_Attached__c',
          type: 'boolean'
        },
        "Is_this_document_on_File__c": {
          name: 'Is_this_document_on_File__c',
          type: 'boolean'
        },
        "License_Detail__c": {
          name: 'License_Detail__c',
          type: 'string'
        },
        "License_Number__c": {
          name: 'License_Number__c',
          type: 'string'
        },
        "License_Issue_Date__c": {
          name: 'License_Issue_Date__c',
          type: 'Date'
        },
        "License_Expiration_Date__c": {
          name: 'License_Expiration_Date__c',
          type: 'Date'
        },
        "Skilling__c": {
          name: 'Skilling__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
